export const namespace = "tool/";
export const SET_COLOR = "SET_COLOR";
export const SET_SIZE = "SET_SIZE";
export const SET_TOOL = "SET_TOOL";
export const SET_TEXT_STATE = "SET_TEXT_STATE";
export const SET_TEXT_TRANS = "SET_TEXT_TRANS";
export const RESET_TEXT_TOOL = "RESET_TEXT_TOOL";
export const ADD_TEXT = "ADD_TEXT";
export const CANCEL_TEXT = "CANCEL_TEXT";
export const RESET_TEXT = "RESET_TEXT";
/**
 * ローカルストレージに保存してたtextsをtool.text.textsに戻す
 * @type {string}
 */
export const RESTORE_TEXTS = "RESTORE_TEXTS";
export const SET_PALETTE_OPEN = "SET_PALETTE_OPEN";

// Text のフローのステート
export const TEXT_STATE_COLOR = "TEXT_STATE_COLOR";
export const TEXT_STATE_INPUT = "TEXT_STATE_INPUT";
export const TEXT_STATE_TRANSFORM = "TEXT_STATE_TRANSFORM";


export const TEXT_TRANS_MOVE = "TEXT_TRANS_MOVE";
export const TEXT_TRANS_SCALE = "TEXT_TRANS_SCALE";
export const TEXT_TRANS_ROTATION = "TEXT_TRANS_ROTATION";
